export const LANDING_PAGE_TOMATO = {
  MAIN: "/",
};
